export const phoneRegex =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
export const onlyAlphabets = /^[A-Za-z]+$/;
export const passwordRegex =
  // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#^,/()+-=*_<>?`~"'|])[A-Za-z\d@$!%*?&.#^,/()+-=*_<>?`~"'|]{6,}$/;
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#^<>|])[A-Za-z\d@$!%*?&.#^<>|]{6,}$/;
export const passwordMessage = (
  <>
    Password must be at least 6 characters, non alphanumeric character, one
    digit ('0'-'9'), one uppercase ('A'-'Z'), one lowercase ('a'-'z'), one
    special character{" "}
    {/* <li>Password must have at least one non alphanumeric character</li>
      <li>Password must have at least one digit ('0'-'9')</li>
      <li>Password must have at least one uppercase ('A'-'Z')</li>
      <li>Password must have at least one lowercase ('a'-'z')</li>
      <li>Password must have at least one special character</li> */}
  </>
);
export const leadingSpaces = /^(?!\s)[\s\S]{5,}$/;
export const leadingSpacesforRelation = /^(?!\s)[\s\S]{3,}$/;

export const shortPasswordRegex =
  /^(?=.*[0-9!@#$%^&*()_+{}[\]:;<>,.?~\\/-]).{8,}$/;

// /^(?=(?:[^a-z]*[a-z]){1,})(?=(?:[^A-Z]*[A-Z]){1,}|(?:[^\d]*\d){1,}).{8,}$/;     it is for strong password with uppercase and lowercase
